import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import Translate from '@client/components/shared/translation/Translate';

import { CancelIcon } from '../SvgIcons';
// workaround for Fork
import styles from './modalDialog.scss';
/* eslint-disable react/prefer-stateless-function */

export class ModalDialog extends React.Component {

    constructor() {
        super();
        this.containerClick = this.containerClick.bind(this);
    }

    render() {
        const {
            size,
            children,
            title,
            isShown,
            closeCampaign,
            closeOnBackdropClicked,
            noMobileFullScreen
        } = this.props;

        return (
            <div styleName={classNames('backdrop', { 'backdrop--visible': isShown })}
                onClick={closeOnBackdropClicked ? closeCampaign : null}
            >
                <div styleName={classNames('wrapper', size, { 'wrapper--no-full-screen': noMobileFullScreen })} onClick={this.containerClick}>
                    <div styleName="title">
                        <Translate message={title} />
                    </div>
                    <div styleName="close-button" onClick={closeCampaign}>
                        <CancelIcon />
                    </div>
                    <div styleName="content-wrapper">
                        { children }
                    </div>
                </div>
            </div>
        );
    }

    containerClick(e) {
        e.stopPropagation();
    }
}

ModalDialog.propTypes = {
    children: PropTypes.object,
    size: PropTypes.string.isRequired,
    isShown: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    closeOnBackdropClicked: PropTypes.bool,
    closeCampaign: PropTypes.func.isRequired,
    noMobileFullScreen: PropTypes.bool
};

export default CSSModules(ModalDialog, styles, { allowMultiple: true });
